import { LoadableAfterPaint } from '@confluence/loadable';

export const InProductHelpButton = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ButtonsInProductHelpButton" */ '../src/Buttons/InProductHelpButton'
			)
		).InProductHelpButton,
});
